module.exports = __webpack_public_path__ + "img/1x.e6871d6.jpg";